import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10.38 3.1a7.28 7.28 0 0 1 7.28 7.28 7.245 7.245 0 0 1-1.537 4.47l4.513 4.513a.9.9 0 1 1-1.273 1.273l-4.513-4.513a7.245 7.245 0 0 1-4.47 1.537 7.28 7.28 0 0 1 0-14.56Zm0 1.8a5.48 5.48 0 1 0 0 10.96 5.48 5.48 0 0 0 0-10.96Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "search-icon"}) } }